export default "__VITE_ASSET__DE29RiqA__"